import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const PreferredVendorsSection = ({ id }) => {
  const [vendors, setVendors] = useState([]);
  const [vendorDetails, setVendorDetails] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchVendors();
  }, [id]);

  useEffect(() => {
    if (vendors?.length && $(".service-slider").length) {
      const $slider = $(".service-slider");

      $slider.owlCarousel({
        autoplay: true,
        smartSpeed: 100,
        margin: 30,
        loop: true,
        autoplayHoverPause: true,
        dots: false,
        arrows: false,
        nav: false,
        center: true,
        items: 4,
        stagePadding: 60,
        navText: [
          '<i class="ti-arrow-left"></i>',
          '<i class="ti-arrow-right"></i>',
        ],
        responsive: {
          0: { items: 1, stagePadding: 5 },
          575: { items: 1, stagePadding: 5 },
          767: { items: 2 },
          992: { items: 2 },
          1200: { items: 4 },
        },
      });

      // Delegate click handler for both original and cloned vendor elements
      $slider.on("click", ".vendormodal", function () {
        const vendorId = $(this).data("vendor-id");
        if (vendorId) {
          const vendor = vendors.find((v) => v.vendorServicesID === vendorId);
          if (vendor) {
            setSelectedVendor(vendor);
            fetchVendorDetails(vendorId);
            setIsModalOpen(true);
          }
        }
      });

      // Cleanup
      return () => {
        $slider.trigger("destroy.owl.carousel");
        $slider.off("click", ".vendormodal");
      };
    }
  }, [JSON.stringify(vendors)]);

  const fetchVendors = async () => {
    try {
      const response = await corefetch(
        `PreferedVendors/GetVendorsDetailsByDisplayedInID?displayedInID=${id}`
      );
      if (response && response.length > 0) {
        const mappedServices = response.map((vendor) => ({
          ...vendor,
          image: `${ImageURL}${vendor.imagePath}`,
        }));
        setVendors(mappedServices);
      } else {
        setVendors([]);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setVendors([]);
    }
  };

  const fetchVendorDetails = async (vendorId) => {
    try {
      const response = await corefetch(
        `Vendor/GetApprovedVendorDetails?vendorId=${vendorId}`
      );
      if (response && response.length > 0) {
        setVendorDetails(response);
      } else {
        setVendorDetails([]);
      }
    } catch (error) {
      console.error("Error fetching vendor details:", error);
      setVendorDetails([]);
    }
  };

  const handleVendorClick = (vendorId, e) => {
    if (e?.currentTarget?.classList?.contains("cloned")) return;
    const vendor = vendors.find((v) => v.vendorServicesID === vendorId);
    if (vendor) {
      setSelectedVendor(vendor);
      fetchVendorDetails(vendorId);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setSelectedVendor(null);
    setVendorDetails([]);
    setIsModalOpen(false);
  };

  if (!vendors || vendors.length === 0) {
    return null;
  }

  return (
    <>
      <section className="wpo-team-section pb-0">
        <div className="wpo-section-title">
          <h4>Preferred Vendors</h4>
        </div>
        <div className="wpo-team-wrap">
          <div className="row">
            <div className="service-slider owl-carousel">
              {vendors.map((vendor, index) => (
                <div
                  className="col-lg-3 col-md-6 col-sm-6 col-12 vendormodal"
                  key={index}
                  data-vendor-id={vendor.vendorServicesID}
                >
                  <div className="wpo-team-item wow fadeInUp">
                    <div
                      className={`wpo-team-img ${
                        vendor.imagePath ? "" : "no-image"
                      }`}
                      style={{
                        backgroundImage: vendor.imagePath
                          ? `url(${ImageURL}${vendor.imagePath})`
                          : "none",
                      }}
                    ></div>
                    <div className="wpo-team-text wpo-Service-text-Dum">
                      <p>{vendor.serviceType}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {isModalOpen && (
        <div id="dynamicModal" className="popup">
          <div
            className="modal-content vendors"
            style={{
              maxHeight: "80vh", // Limit modal height to 80% of viewport
              overflowY: "auto", // Enable vertical scrolling
              padding: "20px",
              borderRadius: "8px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header">{selectedVendor.serviceType}</div>
            {vendorDetails.length > 0 && (
              <>
                <table
                  className="table-space-evenly"
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        className="tooltip-label"
                        style={{
                          padding: "10px",
                          textAlign: "left",
                        }}
                      >
                        Vendor Name
                      </th>
                      <th
                        className="tooltip-label"
                        style={{
                          padding: "10px",
                          textAlign: "left",
                        }}
                      >
                        Contact No
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendorDetails.map((detail, idx) => (
                      <tr key={idx}>
                        <td
                          style={{
                            padding: "10px",
                            textAlign: "left",
                          }}
                        >
                          {detail.vendorName}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            textAlign: "left",
                          }}
                        >
                          {detail.phoneNumber}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
            <div
              className="additional-text"
              style={{
                marginTop: "20px",
              }}
            >
              {selectedVendor.description}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PreferredVendorsSection;
